import List from "./components/List"
import Form from "./components/Form"

let module = "checklisttemplatecategory"

export default [
  {
    path: "equipmentchecklists",
    component: List,
    props: true,
    meta: { module: module, permissions: ["checklisttemplatecategory-index"] }
  },
  {
    path: "equipmentchecklist/create",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["checklisttemplatecategory-create"] }
  },
  {
    path: "equipmentchecklist/edit/:id",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["checklisttemplatecategory-edit"] }
  }
]
